import { LuminousGallery } from "luminous-lightbox";

window.addEventListener("DOMContentLoaded", event => {
  const trigger = document.querySelectorAll(".gallery");
  new LuminousGallery(trigger);
});
